// extracted by mini-css-extract-plugin
module.exports = {"modalSuccess":"ModalSuccess_modalSuccess__2i3oP","btnSubmit":"ModalSuccess_btnSubmit__3kow8","copy":"ModalSuccess_copy__2wmy1"};